import routes from './routes';

var conf = {
    app: {
        layout: 'layout', // set global layout here
        name: "Forque",
        heading: "Forque",
        subheading: "Vue2 App",
        wrapperClasses: "container",
        containNavbar: true,
        containFooter: true,
        assetPath: '../assets/'
    },
    sidebar: {
        sidebarLinks: [
            {name:"Dashboards",path:"/",icon:"icon-speedometer icons",
                children:[
                {name:"Dashboard 1",path:"/home"},
                {name:"Dashboard 2",path:"/home1"},
                {name:"Dashboard 3",path:"/home2"},
                {name:"Dashboard 4",path:"/home3"},
                {name:"Dashboard 5",path:"/home4"}]
            },
            {name:"Charts",path:"/charts",icon:"icon-chart icons"},
            {name:"Inbox",path:"/inbox",icon:"icon-drawer icons"},
            {name:"Kanban",path:"/tasks",icon:"icon-notebook icons"},
            {name:"Search",path:"/search",icon:"icon-magnifier icons"},
            {name:"Tables",path:"/tables",icon:"icon-grid icons"},
            {name:"UI Kit",path:"/elements",icon:"icon-layers icons",
                children:[
                    {name:"Icons",path:"/icons"},
                    {name:"Cards & Widgets",path:"/cards"},
                    {name:"Forms",path:"/forms"},
                    {name:"Alerts",path:"/elements#alerts"},
                    {name:"Badges & Pills",path:"/elements#badges"},
                    {name:"Breadcrumbs",path:"/elements#breadcrumbs"},
                    {name:"Buttons",path:"/elements#buttons"},
                    {name:"Colors",path:"/elements#colors"},
                    {name:"Progress Bars",path:"/elements#progress"},
                    {name:"Lists & Accordions",path:"/elements#lists"},
                    {name:"Modals",path:"/elements#modals"},
                    {name:"Pagination",path:"/elements#breadcrumbs"},
                    {name:"Tables",path:"/elements#tables"},
                    {name:"Tabs",path:"/elements#tabs"},
                    {name:"Videos",path:"/elements#videos"}]
            },
            {name:"Typography",path:"/typography",icon:"icon-eyeglass icons"},
            {name:"Pages",path:"/timeline",icon:"icon-docs icons",
                children:[
                {name:"Timeline",path:"/timeline",icon:""},
                {name:"Gallery",path:"/gallery",icon:""},
                {name:"Artwork",path:"/artwork",icon:""},
                {name:"Pricing",path:"/pricing",icon:""},
                {name:"FAQ",path:"/faq",icon:""},
                {name:"Error 404",path:"/404",icon:""},
                {name:"Error 500",path:"/500",icon:""}]
            },
            {name:"Layouts",path:"/layout",icon:"icon-grid icons",
                children:[
                {name:"Layout 1",path:"/layout",icon:""},
                {name:"Layout 2",path:"/layout1",icon:""}]
            }
        ]
    },
    routes: routes
};

export default conf;
